'use client';

import { cn } from '@ifixit/ui/lib/utils';
import type { ComponentProps } from 'react';

type TextareaProps = ComponentProps<'textarea'>;

export function Textarea({ className, ...props }: TextareaProps) {
   return (
      <textarea
         data-slot="textarea"
         className={cn(
            'placeholder:text-muted-foreground border-input flex min-h-20 w-full rounded-lg border bg-card px-3 py-2 text-base transition-[color,box-shadow] outline-none md:pointer-fine:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'disabled:pointer-events-none disabled:opacity-50',
            className
         )}
         {...props}
      />
   );
}
